import styled from '@emotion/styled';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import React from 'react';

import { H1, H3, theme } from '@kindur/components';

import withTracking from '../../components/Common/withTracking';
import { BasicLinkButton } from '../../elements/LinkButton';
import chevron from '../../icons/smartdraw/chevron-black.svg';

const Container = styled('div')`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  font-family: 'DM Sans', sans-serif;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1200px;
  padding: 1rem 0 3rem;
  ${theme.breakpoints.smallTabletDown} {
    height: auto;
    flex-flow: column nowrap;
  }
`;
const Padding = styled('div')`
  padding: 40px 24px;
  max-width: 33rem;
  width: 100%;
  text-align: center;
  ${theme.breakpoints.tabletDown} {
    padding: 24px;
    text-align: unset;
    width: unset;
  }
`;
const Title = styled(H1)`
  color: #191919;
  font-family: 'DM Sans', sans-serif;
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 48px;
  margin: 0 auto 16px auto;
  span {
    white-space: nowrap;
  }
  ${theme.breakpoints.tabletDown} {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 12px;
    text-align: center;
  }
`;
const Subtitle = styled(H3)`
  font-family: 'DM Sans', sans-serif;
  font-size: 1.5rem;
  letter-spacing: 0.25px;
  line-height: 32px;
  ${theme.breakpoints.tabletDown} {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 24px;
    text-align: center;
  }
`;
const BulletsContainer = styled('div')`
  margin: 0 auto;
  text-align: left;
  max-width: 330px;
`;
const BulletPoint = styled('div')`
  font-size: 17px;
  letter-spacing: -0.09px;
  line-height: 24px;
  margin: 0 auto 16px auto;
  b {
    font-weight: 700;
  }
  &.bold {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: normal;
    margin: 0 auto;
    text-align: center;
    :before {
      content: '';
    }
  }
  :before {
    content: '> ';
  }
  ${theme.breakpoints.tabletDown} {
    span {
      display: inline-block;
    }
  }
`;
const StartFreePlanButton = styled(BasicLinkButton)`
  background-color: #0af7da;
  border-radius: 3px;
  box-shadow: -2px 2px 0 0 #0b4b40;
  display: flex;
  flex-flow: row-reverse;
  font-size: 18px;
  justify-content: space-between;
  letter-spacing: 0.09px;
  line-height: 24px;
  margin: 24px auto 32px auto;
  padding-left: 24px;
  padding-right: 24px;
  width: 240px;
  ${theme.breakpoints.tabletDown} {
    margin: 24px auto;
  }
`;
const Image = styled(Img)`
  width: 580px;
  ${theme.breakpoints.tabletDown} {
    width: 100%;
  }
`;

const Description = styled('p')`
  font-family: 'DM Sans', sans-serif;
`;

const TrackComponentName = 'Hero';

const Hero = ({ alt, content, image, track }) => {
  return (
    <React.Fragment>
      <Container>
        <Padding>
          <Title>SmartDraw</Title>
          <Subtitle>Our proprietary technology recommends how to make your money last.</Subtitle>
          <Description>We analyze 3,000+ data points and 100+ scenarios to give each Baby Boomer a personalized, tax-efficient retirement plan.</Description>
        </Padding>
        <Image fluid={image} alt={alt} />
      </Container>
    </React.Fragment>
  );
};

Hero.displayName = TrackComponentName;

export default withTracking(Hero);
